export enum OverlayDataKind {
  QuarterlyEarnings = "QUARTERLY_EARNINGS",
  YearlyEarnings = "YEARLY_EARNINGS",
  QuarterlyLosses = "QUARTERLY_LOSSES",
  YearlyLosses = "YEARLY_LOSSES",
  MarketCrisis = "MARKET_CRISIS",
}
export type FlagSeriesData = {
  x: Date | number;
  title?: string;
  value?: number;
  label: string;
  time?: string;
  theme?: {
    backgroundColor?: string;
    textColor?: string;
  };
};

export type ChartOverlay = {
  kind: OverlayDataKind;
  title: string;
  description: string;
  data: FlagSeriesData[];
};
